import { connect } from 'react-redux';
import {
    addFavouriteProject,
    fetchProjects,
    filterProject,
    getAllProject,
    getUnselectedAllProject,
    handleProjectRequestClose,
    hideProjectLoader,
    showProjectLoader,
    onAddProject,
    onAllProjectSelect,
    onProjectClose,
    onProjectSelect,
    onDeleteProject,
    onDeleteSelectedProject,
    onFilterProjectOptionSelect,
    onSaveProject,
    onToggleProjectDrawer,
    updateSearchProject,
    onProjectPrioritiesDashboard,
    onProjectCostPrioritiesDashboard,
    onProjectBusinessPrioritiesDashboard,
    onGlobalProjectCostPrioritiesDashboard,
    onGlobalProjectBusinessPrioritiesDashboard,
    onProjectIssuesDashboard,
    fetchImportProjects,
    onImportProjects,
    showImportProjectsLoader,
    setProject,
} from 'actions/project';
import {
    fetchSecuritys,
} from 'actions/security';
import {
    fetchInitiatives,
} from 'actions/initiative';

import Component from './component';


export const mapStateToProps = ({ projects, settings, orgs, securitys, initiatives }) => {
    const { width } = settings;
    const {
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        project,
        searchProject,
        filterOption,
        allProject,
        projectList,
        selectedProject,
        selectedProjects,
        addProjectState,
        importedProjects,
        importLoader,
    } = projects;
    const {
        selectedOrg
    } = orgs;
    const {
        allSecurity,
    } = securitys;
    const {
        allInitiative,
    } = initiatives;
    return {
        width,
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        project,
        searchProject,
        filterOption,
        allProject,
        projectList,
        selectedProject,
        selectedProjects,
        addProjectState,
        importedProjects,
        importLoader,
        selectedOrg,
        allSecurity,
        allInitiative,
    };
};
export default connect(mapStateToProps, {
    fetchProjects,
    addFavouriteProject,
    onProjectSelect,
    onAddProject,
    onProjectClose,
    onFilterProjectOptionSelect,
    onSaveProject,
    onDeleteProject,
    onDeleteSelectedProject,
    filterProject,
    getAllProject,
    getUnselectedAllProject,
    onAllProjectSelect,
    updateSearchProject,
    onToggleProjectDrawer,
    handleProjectRequestClose,
    hideProjectLoader,
    showProjectLoader,
    onProjectPrioritiesDashboard,
    onProjectCostPrioritiesDashboard,
    onProjectBusinessPrioritiesDashboard,
    onGlobalProjectCostPrioritiesDashboard,
    onGlobalProjectBusinessPrioritiesDashboard,
    onProjectIssuesDashboard,
    fetchImportProjects,
    showImportProjectsLoader,
    onImportProjects,
    fetchSecuritys,
    setProject,
    fetchInitiatives,
})(Component);


// WEBPACK FOOTER //
// ./components/Agile/project/container.js